import moment from 'moment';

export function useFormatters() {
  const number_format = (value) => {
    if (isFinite(value) && value !== null) {
      let formatter = new Intl.NumberFormat('ja-JP', { minimumIntegerDigits: 1, maximumFractionDigits: 1, minimumFractionDigits: 0 });
      return formatter.format(value);
    } else {
      return '-';
    }
  };

  const number_format_yen = (value) => {
    if (isFinite(value) && value !== null) {
      let formatter = new Intl.NumberFormat('ja-JP', { minimumIntegerDigits: 1, maximumFractionDigits: 1, minimumFractionDigits: 0 });
      return '￥' + formatter.format(value);
    } else {
      return '-';
    }
  };

  const number_format_yen_fixed_decimal = (value) => {
    if (isFinite(value) && value !== null) {
      let formatter = new Intl.NumberFormat('ja-JP', { minimumIntegerDigits: 1, maximumFractionDigits: 1, minimumFractionDigits: 1 });
      return '￥' + formatter.format(value);
    } else {
      return '-';
    }
  };

  const percent_format = (value) => {
    if (isFinite(value) && value !== null) {
      return parseFloat(value).toFixed(3) + '%';
    } else {
      return '-';
    }
  };

  const percent_format_cpm = (value) => {
    if (isFinite(value) && value !== null) {
      const totalDigit = 5;
      const decimalDigit = 3;
      value = Math.round(value * (10 ** totalDigit));
      value = value / (10 ** decimalDigit);
      return parseFloat(value).toFixed(decimalDigit) + '%';
    } else {
      return '-';
    }
  };

  const date_format = (value) => {
    return moment(value).format('YYYY/MM/DD');
  };

  const digestive_format = (value) => {
    if (isFinite(value) && value !== null) {
      value = value.toString();
      value = value.split('.');
      value = parseInt(value[0]);
      let formatter = new Intl.NumberFormat('ja-JP', { minimumIntegerDigits: 1, maximumFractionDigits: 0, minimumFractionDigits: 0 });
      return '￥' + formatter.format(value);
    } else {
      return '-';
    }
  };

  return {
    number_format,
    number_format_yen,
    number_format_yen_fixed_decimal,
    percent_format,
    percent_format_cpm,
    date_format,
    digestive_format
  };
}